const Joi = require('joi')

const getUserStatsSchema = Joi.object({
    createdAfter: Joi.date().optional().label('Created After'),
    createdBefore: Joi.date().optional().label('Created Before'),
})

module.exports = getUserStatsSchema